import { render, staticRenderFns } from "./CarrouselCourseViewed.vue?vue&type=template&id=6e2f9d64"
import script from "./CarrouselCourseViewed.vue?vue&type=script&lang=js"
export * from "./CarrouselCourseViewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports